import { contact, navigation } from '../data/site'

export default function Footer() {
  return (
    <footer className="site-footer" data-analytics-section="footer">
      <div className="footer-top">
        <div data-reveal>
          <p className="eyebrow light">Hagamos equipo</p>
          <h2>Construyamos<br /><em>desde la raíz.</em></h2>
        </div>
        <a
          className="footer-project-cta"
          href="/contacto/#cotizar"
          data-analytics-event="cta_click"
          data-analytics-location="footer_project_cta"
          data-analytics-label="Solicitar cotización"
        >
          <span className="footer-project-kicker">¿Tienes un proyecto?</span>
          <strong>Solicitar<br />cotización</strong>
          <span className="footer-project-description">
            Comparte la ubicación, el servicio que necesitas y los datos de tu obra.
          </span>
          <span className="footer-project-action" aria-hidden="true">
            Ir al formulario
            <svg viewBox="0 0 24 24"><path d="M5 19 19 5M8 5h11v11" /></svg>
          </span>
        </a>
      </div>
      <div className="footer-grid">
        <div className="footer-brand-block">
          <img className="footer-logo" src="/images/brand/logo-crs.webp" alt="CRS Cimentaciones" />
          <span className="footer-label">Contacto</span>
          <a href={contact.phoneHref}>{contact.phoneLabel}</a>
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
        </div>
        <div>
          <span className="footer-label">Navegación</span>
          {navigation.slice(1).map((item) => <a key={item.href} href={item.href}>{item.label}</a>)}
        </div>
        <div>
          <span className="footer-label">Cobertura</span>
          <p>Servicio en toda<br />la República Mexicana</p>
        </div>
        <div>
          <span className="footer-label">Síguenos</span>
          <a href="https://www.linkedin.com/company/crscimentaciones/" target="_blank" rel="noreferrer">LinkedIn ↗</a>
          <a href="https://www.instagram.com/crscimentaciones/" target="_blank" rel="noreferrer">Instagram ↗</a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} CRS Cimentaciones</span>
        <a href="/politica-de-privacidad/">Política de privacidad</a>
        <span>Sitio oficial · v1.0</span>
      </div>
    </footer>
  )
}
